/**
 * Mock data pre systémových správcov (Správci)
 * Endpoint: /spravce/api/spravci
 */

export const admins = [
  {
    id: "admin-001",
    firstName: "Jan",
    lastName: "Novák",
    userDn: "CN=Jan Novák,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2020-01-15T08:00:00.000Z",
  },
  {
    id: "admin-002",
    firstName: "Petr",
    lastName: "Svoboda",
    userDn: "CN=Petr Svoboda,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2020-03-20T10:30:00.000Z",
  },
  {
    id: "admin-003",
    firstName: "Marie",
    lastName: "Dvořáková",
    userDn: "CN=Marie Dvořáková,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2021-02-10T14:15:00.000Z",
  },
  {
    id: "admin-004",
    firstName: "Tomáš",
    lastName: "Procházka",
    userDn: "CN=Tomáš Procházka,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2021-06-05T09:45:00.000Z",
  },
  {
    id: "admin-005",
    firstName: "Eva",
    lastName: "Horáková",
    userDn: "CN=Eva Horáková,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2022-01-12T11:00:00.000Z",
  },
  {
    id: "admin-006",
    firstName: "Jiří",
    lastName: "Marek",
    userDn: "CN=Jiří Marek,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2022-04-18T16:20:00.000Z",
  },
  {
    id: "admin-007",
    firstName: "Lucie",
    lastName: "Černá",
    userDn: "CN=Lucie Černá,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2022-08-22T08:30:00.000Z",
  },
  {
    id: "admin-008",
    firstName: "Martin",
    lastName: "Veselý",
    userDn: "CN=Martin Veselý,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2023-02-14T13:45:00.000Z",
  },
  {
    id: "admin-009",
    firstName: "Kateřina",
    lastName: "Nováčková",
    userDn: "CN=Kateřina Nováčková,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2023-07-03T10:00:00.000Z",
  },
  {
    id: "admin-010",
    firstName: "David",
    lastName: "Král",
    userDn: "CN=David Král,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2024-01-08T15:30:00.000Z",
  },
  {
    id: "admin-011",
    firstName: "Michaela",
    lastName: "Pokorná",
    userDn: "CN=Michaela Pokorná,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2024-05-20T09:15:00.000Z",
  },
  {
    id: "admin-012",
    firstName: "Ondřej",
    lastName: "Kučera",
    userDn: "CN=Ondřej Kučera,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2024-09-11T14:00:00.000Z",
  },
  {
    id: "admin-013",
    firstName: "Tereza",
    lastName: "Benešová",
    userDn: "CN=Tereza Benešová,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2025-01-25T11:30:00.000Z",
  },
  {
    id: "admin-014",
    firstName: "Jakub",
    lastName: "Fiala",
    userDn: "CN=Jakub Fiala,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2025-06-10T08:45:00.000Z",
  },
  {
    id: "admin-015",
    firstName: "Veronika",
    lastName: "Sedláčková",
    userDn: "CN=Veronika Sedláčková,OU=Admins,DC=msp,DC=justice,DC=cz",
    created: "2025-11-18T16:00:00.000Z",
  },
];

export default admins;
